import { makeStyles, Theme } from "@material-ui/core";
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { RESULT_CODE } from "../types";
import { API_GATEWAY_URI } from "../contants/Server";
import { detect } from "detect-browser";
import { getDomainInfo, logDomainAccess } from "../utils/domainUtils";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(var(--vh, 1vh) * 100)",
    display: "flex",
    flexDirection: "column",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  textDiv: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    fontSize: "1.2rem",
  },
  textCenter: {
    textAlign: "center"
  },
  marginB2: {
    marginBottom: theme.spacing(2),
  },
  link: {
    cursor: "pointer",
    color: "#2EA8E5",
    textDecoration: "underline",
    "&:hover, &:active": {
      color: "#0095E0",
    },
  },
  vcenter: {
    display: "flex",
    alignItems: "center",
  },
}));

export const AppDownloadScreen = () => {
  const classes = useStyles();

  const browser = detect();
  console.log("browser:", browser);

  const [loading, setLoading] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>();
  const [title, setTitle] = useState<string>("BlackVue");
  const [linkUrl, setLinkUrl] = useState<string>("https://blackvue.com/downloads");

  // 앱 로드 시 도메인 정보 로깅
  const domainInfo = getDomainInfo();

  useEffect(() => {    
    logDomainAccess(domainInfo);
    
    // 추가적인 분석 정보
    console.log('🔍 Environment:', process.env.NODE_ENV);
    console.log('🔍 Build Time:', process.env.REACT_APP_BUILD_TIME || 'Unknown');
    console.log('🔍 Version:', process.env.REACT_APP_VERSION || 'Unknown');
  }, [domainInfo]);

  const callStatistic = useCallback(async (os: string) => {
    try {
      setLoading(true);
      const resp = await axios.post(`${API_GATEWAY_URI}/qrcode?platform=${os}`);
      console.log("resp: ", resp);
      const { resultcode, message } = resp.data as {
        resultcode: RESULT_CODE;
        message: string;
      };
      if (resultcode === "BC_ERR_OK") {
        console.log("success call statistic!");
      } else {
        setErrMsg(message);
      }
    } catch (error: any) {
      console.log("error: ", error);
      setErrMsg(error);
    } finally {
      // if (platform === "IOS") {
      //   //@ts-ignore
      //   window.location.assign("https://apps.apple.com/us/app/blackvue/id1049209637");
      // } 
      // if (platform === "AOS") {
      //   //@ts-ignore
      //   window.location.assign("https://play.google.com/store/apps/details?id=comb.blackvuec");
      // }
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    switch (domainInfo.hostname) {
      case "qrcode.safydirect.com":
        setTitle("Safy Direct");
        if (browser?.os === "iOS") {
          callStatistic("IOS");
          //@ts-ignore
          window.location.assign("https://apps.apple.com/app/safy-direct/id6751835789");
        } else if (browser?.os === "Android OS") {
          callStatistic("AOS");
          //@ts-ignore
          window.location.assign("https://play.google.com/store/apps/details?id=com.apical.safy");
        } else {
          if (browser?.os?.includes("Mac")) {
            setLinkUrl("https://apps.apple.com/app/safy-direct/id6751835789");
          } else if (browser?.os?.includes("Windows")) {
            setLinkUrl("https://play.google.com/store/apps/details?id=com.apical.safy");
          } else {
            console.log("User is on an unknown PC", browser?.os);
          }
        }
        return;
      case "qrcode.blackvuecloud.com":
        if (browser?.os === "iOS") {
          callStatistic("IOS");
          //@ts-ignore
          window.location.assign("https://apps.apple.com/us/app/blackvue/id1049209637");
        } else if (browser?.os === "Android OS") {
          callStatistic("AOS");
          //@ts-ignore
          window.location.assign("https://play.google.com/store/apps/details?id=comb.blackvuec");
        } else {
          //@ts-ignore
          window.location.assign("https://media.blackvue.com/blackvue-app-featuring-blackvue-cloud/");
        }
        return;
      default:
        console.log(browser?.os);
        break;
    }    
  }, [browser?.os, callStatistic, domainInfo.hostname]);

  return (
    <div className="App">
      {loading && (
        <div className="App-loading">
        </div>
      )}
      <div className={classes.root}>
        <div className={classes.body}>
          <div className={classes.textDiv}>
          {errMsg ? errMsg : (
            <div 
              className={classes.textCenter}
              onClick={() => {
                window.location.replace(linkUrl)
              }}
            >
              <span>Go to</span>
              &nbsp;
              <span
                className={classes.link}
              >
                {title}
              </span>
              &nbsp;
              <span>app downloads</span>
            </div>
          )}
          </div>
        </div>
      </div>      
    </div>
  );
};
